export default {
   'floorplanGuide': '3D Floor Plan',
   'floorplanGuideTips': 'Find exhibitors’ virtual booth by one click',
   'liveStream': 'Exhibitor Live Streams',
   'featuredExhibitors': 'Featured Exhibitors',
   'bookingNow': 'Enter',
   'distanceFromLiveTime': {
      'time': 'Start time',
      'noStart': 'Started'
   },
   'viewProductLive': 'View More Exhibits',
   'viewMoreLive': 'More Live Videos',
   'exhTips': 'Quick quotations from multiple suppliers',
   'youMayLike': 'You May Like',
   'concurrentEvents': 'Programmes',
   'footerTitle1': 'Jinhan Fair Online Exhibition 2020',
   'footerTitle2': 'Quick Access:',
   'footerTitle3': 'The Organizer:',
   'footerTitle4': 'October 21-27 ,2020 (UTC/GMT+08:00)',
   'footerQuickAccess1': 'Online exhibition hall',
   'footerQuickAccess2': 'About Jinhan',
   'footerQuickAccess3': 'How to arrive',
   'footerQuickAccess4': 'Download Center',
   'footerQuickAccess5': 'Privacy Protection',
   'footerQuickAccess6': 'Site Map',
   'newText1': '3D Floor Plan',
   'newText2': 'News Center',
   'newText3': 'About Jinhan Fair',
   'newText4': 'Quick Contact',
   'newText5': 'IPR Protection',
   'newText6': 'APP Manual',
   'newText7':'Website Manual',
   'footerComName': 'Guangzhou Poly Jinhan Exhibition Co., Ltd.',
   'footerFax': 'Fax : +86 (0)20 8989 9111',
   'footerTel': 'Tel : +86 (0)20 8989 9633',
   'footerEmail': 'Email : info@jinhanfair.com',
   'footerAddress': 'Location：Guangzhou Poly World Trade Expo',
   'footerAddressTips': '(Opposite Area B, Area C, Canton Fair)',
   'footerSocialMedia': 'Social Media',
   'exhibitor': 'Exhibitors',
   'person': 'Visitors',
   'Home': 'Home',
   'Exhibitor': 'Exhibitors',
   'Products': 'Products',
   'Visitor': 'Visitors',
   'Business': 'Biz Hub',
   'Live': 'Live',
   'About': 'About Us',
   'QA':'Q&A',

   'download': 'Download App',
   'searchPlaceHolder': 'Search'


}